module.exports = __webpack_public_path__ + "static/media/natal.5e790353.png";